import { Injectable } from '@angular/core';
import { fromEvent, map, merge, Subject, takeUntil, throttleTime } from "rxjs";
import { UsersAPIService } from "../../../modules/careplan/users-api.service";
import { UserService } from "../../../core/user/user.service";
import moment from "moment/moment";
import { ActivatedRoute } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class ActivityTrackingService {

    private destroy$ = new Subject<void>();
    private isActive = false;

    constructor(
        private _userService: UserService,
        private _userAPIService: UsersAPIService,
        private _activatedRoute: ActivatedRoute,
    ) {
    }

    /**
     * Start tracking user activity events (clicks, scrolls, keyboard input)
     * and log "activity alert" once per minute when activity is detected
     */
    startTracking(): void {
        // Track clicks anywhere in the document
        const clicks$ = fromEvent<MouseEvent>(document, 'click').pipe(map(_ => 'click'));

        // Track scroll events on window
        const scrolls$ = fromEvent<Event>(document, 'scroll').pipe(map(_ => 'scroll'));

        // Track keydown events for typing detection
        const keydowns$ = fromEvent<KeyboardEvent>(document, 'keydown').pipe(map(_ => 'keydown'));

        // Combine all user activity events into a single stream
        merge(clicks$, scrolls$, keydowns$)
            .pipe(
                // Throttle for 1 minute (60000ms) - only emit the first event, then ignore others for 1 minute
                throttleTime(30_000),

                // Stop tracking when the service is destroyed
                takeUntil(this.destroy$)
            )
            .subscribe((eventType) => {

                console.log('sending activity alert');
                this._userAPIService.sendActivityLog(
                    this._userService.user.id,
                    moment().format(),
                    {
                        connection_id: this._userService.wsConnectionID,
                        current_route: window.location.href,
                        event: eventType

                    }
                ).subscribe((response) => {
                    console.log('activity alert response', response);
                })
            });

        console.log('User activity tracking started');
    }

    /**
     * Stop tracking user activity
     */
    stopTracking(): void {
        this.destroy$.next();
        console.log('User activity tracking stopped');
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
